declare namespace $ {

	type $mol_view__sub_shm_tests_app_run_1 = $mol_type_enforce<
		ReturnType< $shm_tests_app_run['player_controls'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_tests_app_run_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_shm_tests_app_run_3 = $mol_type_enforce<
		ReturnType< $shm_tests_app_run['artifact_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $shm_tests_player__result_shm_tests_app_run_4 = $mol_type_enforce<
		ReturnType< $shm_tests_app_run['result'] >
		,
		ReturnType< $shm_tests_player['result'] >
	>
	type $shm_tests_player__comparison_results_shm_tests_app_run_5 = $mol_type_enforce<
		ReturnType< $shm_tests_app_run['comparison_results'] >
		,
		ReturnType< $shm_tests_player['comparison_results'] >
	>
	type $shm_tests_player__manifest_uri_shm_tests_app_run_6 = $mol_type_enforce<
		ReturnType< $shm_tests_app_run['manifest_uri'] >
		,
		ReturnType< $shm_tests_player['manifest_uri'] >
	>
	type $mol_view__sub_shm_tests_app_run_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__uri_shm_tests_app_run_8 = $mol_type_enforce<
		ReturnType< $shm_tests_app_run['artifact_uri'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__external_shm_tests_app_run_9 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_link['external'] >
	>
	type $mol_link__sub_shm_tests_app_run_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_text__text_shm_tests_app_run_11 = $mol_type_enforce<
		ReturnType< $shm_tests_app_run['error_text'] >
		,
		ReturnType< $mol_text['text'] >
	>
	export class $shm_tests_app_run extends $mol_page {
		run_title( ): string
		player_controls( ): readonly($mol_view)[]
		Header_controls( ): $mol_view
		body_rows( ): readonly($mol_view)[]
		Artifacts_title( ): $mol_view
		artifact_rows( ): readonly($mol_view)[]
		Artifacts_list( ): $mol_list
		artifact_uri( id: any): string
		artifact_title( id: any): string
		error_text( ): string
		result( ): any
		comparison_results( ): readonly(any)[]
		manifest_uri( ): string
		display_title( ): string
		title( ): ReturnType< $shm_tests_app_run['run_title'] >
		head( ): readonly(any)[]
		body( ): ReturnType< $shm_tests_app_run['body_rows'] >
		Player( ): $shm_tests_player
		Artifacts( ): $mol_view
		Artifact( id: any): $mol_link
		Error( ): $mol_text
	}
	
}

//# sourceMappingURL=run.view.tree.d.ts.map